<div class="container-fluid p-4">
  <!-- Header -->
  <div class="page-header">
    <div>
      <h2><i class="bi bi-cash-coin me-2"></i>Contas a Receber</h2>
      <p class="text-muted mb-0">Gerencie pagamentos de pacientes e convênios</p>
    </div>
    <button class="btn btn-primary btn-sm" (click)="openModal()">
      <i class="bi bi-plus-circle me-1"></i> Nova Conta a Receber
    </button>
  </div>
  <hr/>

  <!-- Filtros -->
  <div class="card mb-3">
    <div class="card-body">
      <div class="row g-2">
        <div class="col-md-6">
          <input type="text" class="form-control" placeholder="🔍 Buscar por paciente, convênio, descrição..."
                 [value]="filter.search" (input)="onSearch($any($event.target).value)">
        </div>
      </div>
    </div>
  </div>

  <!-- Tabela -->
  <div class="card">
    <div class="card-body">
      <div *ngIf="loading" class="text-center py-5">
        <div class="spinner-border" role="status"></div>
      </div>

      <div *ngIf="!loading && result.items.length === 0" class="text-center py-5 text-muted">
        <i class="bi bi-inbox" style="font-size: 3rem;"></i>
        <p class="mt-2">Nenhuma conta a receber encontrada</p>
      </div>

      <table *ngIf="!loading && result.items.length > 0" class="table table-hover">
        <thead>
          <tr>
            <th>Paciente/Convênio</th>
            <th>Descrição</th>
            <th>Valor</th>
            <th>Vencimento</th>
            <th>Status</th>
            <th class="text-end">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of result.items">
            <td><strong>{{ r.patientName || r.healthInsuranceName || '-' }}</strong></td>
            <td>{{ r.description }}</td>
            <td>{{ r.amount | currency:'BRL' }}</td>
            <td>{{ fmtDate(r.dueDate) }}</td>
            <td>
              <span class="badge" [class.bg-warning]="r.status === 'Pendente'"
                    [class.bg-success]="r.status === 'Pago'"
                    [class.bg-danger]="r.status === 'Vencido'">
                {{ r.status || 'Pendente' }}
              </span>
            </td>
            <td class="text-end">
              <button class="btn btn-sm btn-outline-primary me-1" (click)="openModal(r)" title="Editar">
                <i class="bi bi-pencil"></i>
              </button>
              <button class="btn btn-sm btn-outline-danger" (click)="delete(r)" title="Excluir">
                <i class="bi bi-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Paginação -->
      <div *ngIf="result.totalCount > result.pageSize" class="d-flex justify-content-between align-items-center mt-3">
        <div class="text-muted">
          Exibindo {{ result.items.length }} de {{ result.totalCount }} registros
        </div>
        <nav>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="result.page === 1">
              <a class="page-link" (click)="result.page > 1 && onPageChange(result.page - 1)">Anterior</a>
            </li>
            <li class="page-item" *ngFor="let p of [].constructor(result.totalPages); let i = index"
                [class.active]="i + 1 === result.page">
              <a class="page-link" (click)="onPageChange(i + 1)">{{ i + 1 }}</a>
            </li>
            <li class="page-item" [class.disabled]="result.page === result.totalPages">
              <a class="page-link" (click)="result.page < result.totalPages && onPageChange(result.page + 1)">Próximo</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" [class.show]="showModal" [style.display]="showModal ? 'block' : 'none'" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ editingId ? 'Editar' : 'Nova' }} Conta a Receber</h5>
        <button type="button" class="btn-close" (click)="showModal = false"></button>
      </div>
      <div class="modal-body">
        <div class="row g-3">
          <!-- Paciente -->
          <div class="col-md-6">
            <label class="form-label">Paciente</label>
            <select class="form-select" [(ngModel)]="form.patientId">
              <option [ngValue]="null">-- Nenhum --</option>
              <option *ngFor="let p of patients" [ngValue]="p.id">{{ p.name }}</option>
            </select>
          </div>

          <!-- Convênio -->
          <div class="col-md-6">
            <label class="form-label">Convênio</label>
            <select class="form-select" [(ngModel)]="form.healthInsuranceId">
              <option [ngValue]="null">-- Nenhum --</option>
              <option *ngFor="let hi of healthInsurances" [ngValue]="hi.id">{{ hi.name }}</option>
            </select>
          </div>

          <!-- Descrição -->
          <div class="col-md-12">
            <label class="form-label">Descrição <span class="text-danger">*</span></label>
            <input type="text" class="form-control" [(ngModel)]="form.description">
          </div>

          <!-- Valor -->
          <div class="col-md-6">
            <label class="form-label">Valor <span class="text-danger">*</span></label>
            <input type="number" class="form-control" [(ngModel)]="form.amount" step="0.01">
          </div>

          <!-- Data de Competência -->
          <div class="col-md-6">
            <label class="form-label">Data de Competência</label>
            <div class="date-input-wrapper">
              <input #competenceDateInput type="text" class="form-control"
                     [(ngModel)]="competenceDateDisplay"
                     (input)="onCompetenceDateInput($event)"
                     placeholder="dd/mm/aaaa"
                     maxlength="10">
              <button type="button" class="date-picker-btn" (click)="toggleCompetenceDatePicker()">
                <i class="bi bi-calendar3"></i>
              </button>
            </div>

            <div class="datepicker-overlay" *ngIf="showCompetenceDatePicker" (click)="showCompetenceDatePicker = false"></div>

            <div class="datepicker-popup" *ngIf="showCompetenceDatePicker"
                 [style.top]="competenceDatePickerTop"
                 [style.left]="competenceDatePickerLeft"
                 (click)="$event.stopPropagation()">
              <div class="datepicker-header">
                <button type="button" class="btn-nav" (click)="competenceDatePickerPreviousMonth()">
                  <i class="bi bi-chevron-left"></i>
                </button>
                <span class="datepicker-month">{{ getCompetenceDatePickerMonthYear() | titlecase }}</span>
                <button type="button" class="btn-nav" (click)="competenceDatePickerNextMonth()">
                  <i class="bi bi-chevron-right"></i>
                </button>
              </div>
              <div class="datepicker-weekdays">
                <div *ngFor="let day of weekDays" class="datepicker-weekday">{{ day }}</div>
              </div>
              <div class="datepicker-days">
                <div *ngFor="let date of competenceDatePickerDays"
                     class="datepicker-day"
                     [class.other-month]="!competenceDatePickerIsCurrentMonth(date)"
                     [class.today]="competenceDatePickerIsToday(date)"
                     [class.selected]="competenceDatePickerIsSelected(date)"
                     (click)="competenceDatePickerSelectDate(date)">
                  {{ date.getDate() }}
                </div>
              </div>
              <div class="datepicker-footer">
                <button type="button" class="btn btn-sm btn-link" (click)="competenceDatePickerSelectToday()">
                  Hoje
                </button>
              </div>
            </div>
          </div>

          <!-- Data de Vencimento -->
          <div class="col-md-6">
            <label class="form-label">Data de Vencimento <span class="text-danger">*</span></label>
            <div class="date-input-wrapper">
              <input #dueDateInput type="text" class="form-control"
                     [(ngModel)]="dueDateDisplay"
                     (input)="onDueDateInput($event)"
                     placeholder="dd/mm/aaaa"
                     maxlength="10">
              <button type="button" class="date-picker-btn" (click)="toggleDueDatePicker()">
                <i class="bi bi-calendar3"></i>
              </button>
            </div>

            <div class="datepicker-overlay" *ngIf="showDueDatePicker" (click)="showDueDatePicker = false"></div>

            <div class="datepicker-popup" *ngIf="showDueDatePicker"
                 [style.top]="dueDatePickerTop"
                 [style.left]="dueDatePickerLeft"
                 (click)="$event.stopPropagation()">
              <div class="datepicker-header">
                <button type="button" class="btn-nav" (click)="dueDatePickerPreviousMonth()">
                  <i class="bi bi-chevron-left"></i>
                </button>
                <span class="datepicker-month">{{ getDueDatePickerMonthYear() | titlecase }}</span>
                <button type="button" class="btn-nav" (click)="dueDatePickerNextMonth()">
                  <i class="bi bi-chevron-right"></i>
                </button>
              </div>
              <div class="datepicker-weekdays">
                <div *ngFor="let day of weekDays" class="datepicker-weekday">{{ day }}</div>
              </div>
              <div class="datepicker-days">
                <div *ngFor="let date of dueDatePickerDays"
                     class="datepicker-day"
                     [class.other-month]="!dueDatePickerIsCurrentMonth(date)"
                     [class.today]="dueDatePickerIsToday(date)"
                     [class.selected]="dueDatePickerIsSelected(date)"
                     (click)="dueDatePickerSelectDate(date)">
                  {{ date.getDate() }}
                </div>
              </div>
              <div class="datepicker-footer">
                <button type="button" class="btn btn-sm btn-link" (click)="dueDatePickerSelectToday()">
                  Hoje
                </button>
              </div>
            </div>
          </div>

          <!-- Forma de Pagamento -->
          <div class="col-md-6">
            <label class="form-label">Forma de Pagamento</label>
            <input type="text" class="form-control" [(ngModel)]="form.paymentMethod" placeholder="Ex: Dinheiro, Cartão, PIX">
          </div>

          <!-- Status -->
          <div class="col-md-12">
            <label class="form-label">Status</label>
            <select class="form-select" [(ngModel)]="form.status">
              <option value="Pendente">Pendente</option>
              <option value="Pago">Pago</option>
              <option value="Vencido">Vencido</option>
            </select>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="showModal = false" [disabled]="saving">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving">
          <span *ngIf="saving" class="spinner-border spinner-border-sm me-1"></span>
          Salvar
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade" [class.show]="showModal" *ngIf="showModal"></div>
